import {
  decimalDegreeCordinateMask,
  DDMMSSCordinateMask,
  UTMCordinateMask,
} from 'services/utils/inputMasks';

export const typeOptions = [
  {
    value: 'DD',
    label: 'Grau decimal',
    fieldLabels: {
      lng: 'Longitude',
      lat: 'Latitude',
    },
    mask: {
      lng: decimalDegreeCordinateMask(2, 7),
      lat: decimalDegreeCordinateMask(2, 7),
    },
    placeholder: {
      lng: '-00,0000000',
      lat: '-00,0000000',
    },
    endAdornment: '°',
    projection: 'SIRGAS2000',
  },
  {
    value: 'DMS',
    label: 'Grau/Min/Seg',
    fieldLabels: {
      lng: 'Longitude',
      lat: 'Latitude',
    },
    mask: {
      lng: DDMMSSCordinateMask(),
      lat: DDMMSSCordinateMask(),
    },
    placeholder: {
      lng: '-00°00\'00,0000"',
      lat: '-00°00\'00,0000"',
    },
    endAdornment: null,
    projection: 'SIRGAS2000',
  },
  {
    value: 'UTM',
    label: 'UTM',
    fieldLabels: {
      lng: 'E (X)',
      lat: 'N (Y)',
    },
    mask: {
      lng: UTMCordinateMask('longitude'),
      lat: UTMCordinateMask('latitude'),
    },
    placeholder: {
      lng: '000000.00',
      lat: '0000000.00',
    },
    endAdornment: 'm',
    projection: 'SIRGAS2000',
  },
];

export const timezoneOptions = [
  { value: '23', label: '23' },
  { value: '24', label: '24' },
];

export default [
  {
    ...typeOptions[0],
    csvLabel: 'Grau decimal',
    epsg: '4674',
    csv: true,
  },
  {
    ...typeOptions[2],
    csvLabel: 'UTM 23',
    epsg: '31983',
    zone: timezoneOptions[0],
    csv: true,
  },
  {
    ...typeOptions[2],
    csvLabel: 'UTM 24',
    epsg: '31984',
    zone: timezoneOptions[1],
    csv: true,
  },
];
